import React, { useState, useEffect } from 'react';
import ContactModal from './ContactModal';



const getSlideHeading = (title) => {
  if (title.includes(':')) {
    return (
      <>
        {title.split(':')[0]}<span className="text-[#e16338]">:</span>{title.split(':')[1]}
      </>
    );
  } else {
    const [first, ...rest] = title.split(' ');
    return (
      <>
        {first} <span className="text-[#e16338]">{rest.join(' ')}</span>
      </>
    );
  }
};

const OurStory = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const slides = [
    {
      title: 'The Challenge',
      content: (
        <ul className="space-y-6 text-lg mt-8">
          <li className="flex items-center gap-3">
            <div className="h-2 w-2 rounded-full bg-[#e16338]"></div>
            <span>Classrooms in India are 90% teacher-directed</span>
          </li>
          <li className="flex items-center gap-3">
            <div className="h-2 w-2 rounded-full bg-[#e16338]"></div>
            <span>Less than 10% of lessons involve student-led questioning or discussion</span>
          </li>
          <li className="flex items-center gap-3">
            <div className="h-2 w-2 rounded-full bg-[#e16338]"></div>
            <span>Only 42-44% of Indian graduates deemed employable in early 2025</span>
          </li>
          <li className="flex items-center gap-3">
            <div className="h-2 w-2 rounded-full bg-[#e16338]"></div>
            <span>Major skills gap in critical thinking and problem-solving</span>
          </li>
        </ul>
      ),
      image: '/challenge.jpg',
      layout: 'twocol',
    },
    {
      title: 'The Problem',
      content: (
        <blockquote className="text-lg italic mt-8 text-gray-800 border-l-4 border-[#e16338] pl-6">
          "It all started when I was in my classroom and my students (grade 3) were constantly dependent on me as an adult to think for them. If I asked them to discuss or think of an answer by themselves, they would straight up refuse! They were adamant about me writing the answers on the board so that they could just copy it down and learn it by heart."
        </blockquote>
      ),
      image: '/problem.jpg',
      layout: 'twocol',
    },
    {
      title: 'Our Solution',
      content: (
        <div className="space-y-8">
          <p className="text-lg mb-6">
            Aaravam Labs is a transformative program that empowers students to become confident problem-solvers by tackling real-world challenges in their communities. Through our innovative approach, we're reshaping how students learn and grow.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Card 1 */}
            <div className="bg-[#f9f8f3] p-6 rounded-xl shadow-sm">
              <div className="flex items-center gap-4 mb-4">
                <svg width="40" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M1 4H5C5.55228 4 6 4.44772 6 5V19C6 19.5523 5.55228 20 5 20H1C0.44772 20 0 19.5523 0 19V5C0 4.44772 0.44772 4 1 4zM2 13V17C2 17.5523 2.44772 18 3 18C3.55228 18 4 17.5523 4 17V13C4 12.4477 3.55228 12 3 12C2.44772 12 2 12.4477 2 13zM8 0H12C12.5523 0 13 0.44772 13 1V19C13 19.5523 12.5523 20 12 20H8C7.44772 20 7 19.5523 7 19V1C7 0.44772 7.44772 0 8 0zM9 11V17C9 17.5523 9.4477 18 10 18C10.5523 18 11 17.5523 11 17V11C11 10.4477 10.5523 10 10 10C9.4477 10 9 10.4477 9 11zM15 2H19C19.5523 2 20 2.44772 20 3V19C20 19.5523 19.5523 20 19 20H15C14.4477 20 14 19.5523 14 19V3C14 2.44772 14.4477 2 15 2zM16 15V17C16 17.5523 16.4477 18 17 18C17.5523 18 18 17.5523 18 17V15C18 14.4477 17.5523 14 17 14C16.4477 14 16 14.4477 16 15z" fill="#e16338"/>
                </svg>
                <h3 className="text-xl font-semibold text-gray-800">Seamless Curriculum Integration</h3>
              </div>
              <p className="text-gray-700">
                Fits effortlessly into existing curriculum (just 2-3 hours weekly)
              </p>
            </div>
            {/* Card 2 */}
            <div className="bg-[#f9f8f3] p-6 rounded-xl shadow-sm">
              <div className="flex items-center gap-4 mb-4">
                <svg width="40" height="40" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path className="st0" fill="#e16338" d="M341.809,463.578c-1.576,0-3.152-0.074-4.729-0.228l-5.329,14.868c7.654-0.448,15.087-1.049,22.22-1.649l-4.883-13.512C346.684,463.35,344.287,463.578,341.809,463.578z"/>
                    <path className="st0" fill="#e16338" d="M459.672,449.318c-10.887-81.603-53.451-102.028-118.464-122.892c-22.895-7.361-27.924-11.26-27.924-36.334c0-8.709,0,0,0-15.014c11.261-12.544,15.388-10.96,24.919-60.057c19.222,0,18.019-25.08,27.103-47.22c7.353-18.094,1.203-25.454-5.029-28.379c12.682-62.308-4.655-115.759-69.668-125.37C263.512-9.144,217.04,2.49,197.67,6.317c-19.369,3.908-27.176,1.958-27.176,1.958l3.907,27.096c-24.626,29.882-26.656,87.306-23.423,104.425c-5.931,3.226-11.334,10.659-4.281,28.005c9.083,22.14,7.881,47.22,27.103,47.22c9.531,49.097,13.658,47.513,24.919,60.057c0,15.014,0,6.305,0,15.014c0,25.073-5.029,28.973-27.925,36.334C105.782,347.291,63.217,367.715,52.33,449.318c-2.024,14.933,83.708,31.224,203.674,31.224c14.032,0,27.624-0.22,40.608-0.594l10.44-28.98c-11.861-9.985-19.442-24.926-19.442-41.59c0-29.956,24.244-54.28,54.199-54.28c29.956,0,54.199,24.325,54.199,54.28c0,15.688-6.678,29.801-17.419,39.713l8.564,23.87C433.317,466.811,460.794,457.874,459.672,449.318z"/>
                  </g>
                </svg>
                <h3 className="text-xl font-semibold text-gray-800">Student-Driven Experience</h3>
              </div>
              <p className="text-gray-700">
                Students take complete ownership of their learning journey with minimal teacher intervention
              </p>
            </div>
            {/* Card 3 */}
            <div className="bg-[#f9f8f3] p-6 rounded-xl shadow-sm">
              <div className="flex items-center gap-4 mb-4">
                <svg width="40" height="40" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path fill="#e16338" d="M128.371,334.192c-2.533-2.055-5.094-4.07-7.535-6.254l-0.026,0.054c-0.062-0.054-0.129-0.101-0.191-0.156
        L60.074,457.531l-1.738,4.656l2.289,3.633c1.658,2.523,4.344,4.023,7.342,4.023h1.422l57.861-17.996l22.893,54.785
        c1.42,3.234,4.5,5.367,8.052,5.367c3.395,0,6.473-1.973,7.893-5.055l46.828-100.289l13.844-29.484
        c-0.023-0.004-0.049-0.008-0.072-0.012l0.106-0.226C189.916,371.668,156.213,356.418,128.371,334.192z"/>
                    <path fill="#e16338" d="M404.978,357.258l-13.598-29.242c-0.018,0.012-0.035,0.027-0.053,0.043l-0.105-0.222
        c-27.236,23.996-60.971,40.789-98.039,47.57c-2.611,0.457-5.203,0.996-7.838,1.348l0.028,0.058
        c-0.082,0.012-0.162,0.031-0.244,0.043l60.703,130.09c1.422,3.082,4.5,5.055,7.894,5.055c3.553,0,6.631-2.133,8.051-5.367
        l22.895-54.785l56.756,17.602l1.342,0.394h1.186c2.998,0,5.682-1.5,7.34-4.023l2.369-4.422L404.978,357.258z"/>
                    <path fill="#e16338" d="M429.588,173.664C429.588,77.754,351.832,0,255.922,0C160.01,0,82.256,77.754,82.256,173.664
        c0,95.992,77.754,173.668,173.666,173.668C351.832,347.332,429.588,269.656,429.588,173.664z M255.922,254.106
        c-44.285,0-80.36-36.078-80.36-80.442c0-44.285,36.074-80.359,80.36-80.359c44.363,0,80.438,36.074,80.438,80.359
        C336.36,218.027,300.285,254.106,255.922,254.106z"/>
                  </g>
                </svg>
                <h3 className="text-xl font-semibold text-gray-800">Visible Results</h3>
              </div>
              <p className="text-gray-700">
                Meaningful improvements within months—increased engagement, stronger critical thinking, and better academic performance
              </p>
            </div>
          </div>
        </div>
      ),
      layout: 'full',
    },
    {
      title: 'How It Works',
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Step 1 */}
          <div className="bg-white rounded-xl shadow p-6 flex flex-col h-full">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 rounded-full bg-[#e16338] text-white flex items-center justify-center font-bold mr-4">1</div>
              <h3 className="font-semibold text-lg text-gray-900">Pre-Program Evaluation</h3>
            </div>
            <ul className="list-disc pl-6 text-gray-700 space-y-1">
              <li>Aaravam team visits to evaluate students' proficiency levels</li>
              <li>Identify specific support the school requires</li>
            </ul>
          </div>
          {/* Step 2 */}
          <div className="bg-white rounded-xl shadow p-6 flex flex-col h-full">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 rounded-full border-2 border-[#e16338] text-[#e16338] flex items-center justify-center font-bold mr-4">2</div>
              <h3 className="font-semibold text-lg text-gray-900">Customizing Program</h3>
            </div>
            <ul className="list-disc pl-6 text-gray-700 space-y-1">
              <li>Present evaluation findings to school leadership</li>
              <li>Develop implementation strategy based on school and students' needs</li>
            </ul>
          </div>
          {/* Step 3 */}
          <div className="bg-white rounded-xl shadow p-6 flex flex-col h-full">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 rounded-full border-2 border-[#e16338] text-[#e16338] flex items-center justify-center font-bold mr-4">3</div>
              <h3 className="font-semibold text-lg text-gray-900">Program Starts</h3>
            </div>
            <ul className="list-disc pl-6 text-gray-700 space-y-1">
              <li>Monthly real-life problem statements identified by students themselves</li>
              <li>Introduction to creative problem-solving frameworks like design thinking</li>
              <li>Minimal teacher intervention</li>
            </ul>
          </div>
          {/* Step 4 */}
          <div className="bg-white rounded-xl shadow p-6 flex flex-col h-full">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 rounded-full border-2 border-green-500 text-green-500 flex items-center justify-center font-bold mr-4">4</div>
              <h3 className="font-semibold text-lg text-gray-900">Annual Assessment</h3>
            </div>
            <ul className="list-disc pl-6 text-gray-700 space-y-1">
              <li>Students showcase their work</li>
              <li>Comprehensive assessment</li>
              <li>Every student develops their own personal portfolio website</li>
            </ul>
          </div>
        </div>
      ),
      layout: 'full',
    },
    {
      title: 'Projects',
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Project 1 */}
          <div className="bg-white p-4 flex flex-col items-center h-64">
            <img src="/project1.webp" alt="Foosball with waste" className="w-full h-40 object-contain" />
            <div className="text-lg font-bold text-[#e16338] text-center mt-2">Foosball with waste</div>
          </div>
          {/* Project 2 */}
          <div className="bg-white p-4 flex flex-col items-center h-64">
            <img src="/project2.webp" alt="Puppet show to make learning more engaging" className="w-full h-40 object-contain" />
            <div className="text-lg font-bold text-[#e16338] text-center mt-2">Puppet show to make learning more engaging</div>
          </div>
          {/* Project 3 */}
          <div className="bg-white p-4 flex flex-col items-center h-64">
            <img src="/project4.webp" alt="Reading culture in the community" className="w-full h-40 object-contain" />
            <div className="text-lg font-bold text-[#e16338] text-center mt-2">Reading culture in the community</div>
          </div>
          {/* Project 4 */}
          <div className="bg-white p-4 flex flex-col items-center h-64">
            <img src="/project3.webp" alt="Shapes mat for physical education" className="w-full h-40 object-contain" />
            <div className="text-lg font-bold text-[#e16338] text-center mt-2">Shapes mat for physical education</div>
          </div>
        </div>
      ),
      layout: 'full',
    },
    {
      title: 'Impact',
      content: (
        <div className="w-full flex flex-col gap-12 py-8">
          {/* Growth Section */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-center text-[#e16338] mb-6">Growth in 250 children (1 year)</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Problem Solving Card */}
              <div className="bg-white rounded-xl shadow p-6 flex flex-col items-center">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{background:'#D8C49A'}}>
                  <span className="text-2xl font-bold text-gray-900">70%</span>
                </div>
                <div className="text-xl font-semibold text-gray-800 mb-1">Problem Solving</div>
                <div className="text-gray-600 text-center text-base">Growth in students' ability to solve real-world problems</div>
              </div>
              {/* Critical Thinking Card */}
              <div className="bg-white rounded-xl shadow p-6 flex flex-col items-center">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{background:'#FF6C1B'}}>
                  <span className="text-2xl font-bold text-white">85%</span>
                </div>
                <div className="text-xl font-semibold text-gray-800 mb-1">Critical Thinking</div>
                <div className="text-gray-600 text-center text-base">Increase in students' critical thinking skills</div>
              </div>
              {/* Inferential Thinking Card */}
              <div className="bg-white rounded-xl shadow p-6 flex flex-col items-center">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{background:'#2C8DCB'}}>
                  <span className="text-2xl font-bold text-white">100%</span>
                </div>
                <div className="text-xl font-semibold text-gray-800 mb-1">Inferential Thinking</div>
                <div className="text-gray-600 text-center text-base">Mastery in drawing conclusions from evidence</div>
              </div>
            </div>
          </div>
          {/* Divider or Subheading */}
          <div className="flex items-center my-4">
            <div className="flex-grow border-t border-gray-200"></div>
            <span className="mx-4 text-gray-500 font-medium">Our Reach</span>
            <div className="flex-grow border-t border-gray-200"></div>
          </div>
          {/* Reach Section */}
          <div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Low income private schools */}
              <div className="bg-white rounded-xl shadow p-6 flex flex-col items-center">
                <div className="w-16 h-16 rounded-full bg-[#e16338] flex items-center justify-center text-2xl font-extrabold text-black mb-4">04</div>
                <div className="text-xl md:text-2xl font-bold text-black text-center">Low income private schools</div>
              </div>
              {/* Government school */}
              <div className="bg-white rounded-xl shadow p-6 flex flex-col items-center">
                <div className="w-16 h-16 rounded-full bg-[#e16338] flex items-center justify-center text-2xl font-extrabold text-black mb-4">01</div>
                <div className="text-xl md:text-2xl font-bold text-black text-center">Government school</div>
              </div>
              {/* Private school */}
              <div className="bg-white rounded-xl shadow p-6 flex flex-col items-center">
                <div className="w-16 h-16 rounded-full bg-[#e16338] flex items-center justify-center text-2xl font-extrabold text-black mb-4">01</div>
                <div className="text-xl md:text-2xl font-bold text-black text-center">Private school</div>
              </div>
            </div>
          </div>
        </div>
      ),
      layout: 'full',
    },
    {
      title: 'Packages',
      content: (
        <div className="space-y-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Starter Plan */}
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Basic</h3>
                <p className="text-gray-500">For schools starting their journey into independent thinking based learning.</p>
              </div>
              <div className="space-y-6">
                <div className="space-y-2">
                  <p className="font-medium text-gray-900 lg:hidden">What's Included:</p>
                  <ul className="space-y-3 text-gray-600">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Pre-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Curriculum
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Facilitator Training
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Post-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Grade 3rd - 6th
                    </li>
                  </ul>
                </div>
              </div>
            </div>
  
            {/* Core Plan */}
            <div className="bg-white rounded-2xl p-6 shadow-lg relative border-2 border-[#e16338]">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-[#e16338] text-white px-4 py-1 rounded-full text-sm font-medium">Most Popular</span>
              </div>
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Core</h3>
                <p className="text-gray-500">For Schools wanting full experience</p>
              </div>
              <div className="space-y-6">
                <div className="space-y-2">
                  <p className="font-medium text-gray-900 lg:hidden">What's Included:</p>
                  <ul className="space-y-3 text-gray-600">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Pre-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Curriculum
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span className="font-semibold">Aaravam Trained Facilitator(s)</span>
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Post-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Grade 3rd - 6th
                    </li>
                  </ul>
                </div>
              </div>
            </div>
  
            {/* Innovator Plan */}
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Innovator</h3>
                <p className="text-gray-500">For Schools aiming for career readiness</p>
              </div>
              <div className="space-y-6">
                <div className="space-y-2">
                  <p className="font-medium text-gray-900 lg:hidden">What's Included:</p>
                  <ul className="space-y-3 text-gray-600">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Pre-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Curriculum
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span className="font-semibold">Aaravam Trained Facilitator(s)</span>
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Post-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span className="font-semibold">Grade 6th - 9th</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      layout: 'full',
    },
    {
      title: 'Basic',
      content: (
        <div className="space-y-8">
          {/* SVG Icon */}
          <div className="flex justify-start mb-4">
            <span aria-label="Basic icon" role="img">
              {/* SVG once */}
              <svg width="48" height="48" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="#24bac5" d="M32 20.8V62l20-18.8V2z"></path><path fill="#ffce31" d="M12 2v41.2L32 62V20.8z"></path><path fill="none" stroke="#3e4347" strokeLinejoin="round" strokeLinecap="round" strokeWidth="3" strokeMiterlimit="10" d="M32 20.8L12 2v41.2L32 62l20-18.8V2z"></path></svg>
            </span>
          </div>
          <div>
            <p className="text-lg mb-2 font-semibold">Introductory model for schools starting their journey into independent thinking and design-based learning.</p>
            <p className="text-lg mb-2">Aaravam trains the school's existing teachers to run the sessions.</p>
            <p className="text-lg mb-2">Teachers deliver 2 sessions per week using Aaravam's structured curriculum and resources.</p>
            <p className="text-lg mb-2">Light-touch program ideal for schools looking for low-cost innovation.</p>
          </div>
          <div>
            <h3 className="font-bold text-xl mb-2 text-[#e16338]">Key Features:</h3>
            <ul className="list-disc pl-6 space-y-2 text-lg">
              <li>Teacher training and certification by Aaravam</li>
              <li>Ready-to-use monthly problem statements and project guides</li>
              <li>Focus on building basic critical thinking and independent learning habits</li>
            </ul>
          </div>
        </div>
      ),
      layout: 'full',
    },
    {
      title: 'Core',
      content: (
        <div className="space-y-8">
          {/* SVG Icon x2 */}
          <div className="flex justify-start gap-2 mb-4">
            <span aria-label="Core icon" role="img">
              <svg width="48" height="48" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="#24bac5" d="M32 20.8V62l20-18.8V2z"></path><path fill="#ffce31" d="M12 2v41.2L32 62V20.8z"></path><path fill="none" stroke="#3e4347" strokeLinejoin="round" strokeLinecap="round" strokeWidth="3" strokeMiterlimit="10" d="M32 20.8L12 2v41.2L32 62l20-18.8V2z"></path></svg>
            </span>
            <span aria-label="Core icon" role="img">
              <svg width="48" height="48" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="#24bac5" d="M32 20.8V62l20-18.8V2z"></path><path fill="#ffce31" d="M12 2v41.2L32 62V20.8z"></path><path fill="none" stroke="#3e4347" strokeLinejoin="round" strokeLinecap="round" strokeWidth="3" strokeMiterlimit="10" d="M32 20.8L12 2v41.2L32 62l20-18.8V2z"></path></svg>
            </span>
          </div>
          <div>
            <p className="text-lg mb-2 font-semibold">Core offering designed to deeply embed design thinking and independent learning.</p>
            <p className="text-lg mb-2">Dedicated Aaravam-trained facilitator runs 2 sessions per week at the school.</p>
            <p className="text-lg mb-2">Students complete monthly projects and develop real-world problem-solving skills.</p>
          </div>
          <div>
            <h3 className="font-bold text-xl mb-2 text-[#e16338]">Key Features:</h3>
            <ul className="list-disc pl-6 space-y-2 text-lg">
              <li>Full implementation by expert facilitators</li>
              <li>Hands-on design thinking sessions across the year</li>
              <li>Student portfolios and project showcases</li>
              <li>Continuous assessment and feedback system</li>
              <li>Stronger shift toward self-driven learning and critical thinking</li>
            </ul>
          </div>
        </div>
      ),
      layout: 'full',
    },
    {
      title: 'Innovator',
      content: (
        <div className="space-y-8">
          {/* SVG Icon x3 */}
          <div className="flex justify-start gap-2 mb-4">
            <span aria-label="Innovator icon" role="img">
              <svg width="48" height="48" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="#24bac5" d="M32 20.8V62l20-18.8V2z"></path><path fill="#ffce31" d="M12 2v41.2L32 62V20.8z"></path><path fill="none" stroke="#3e4347" strokeLinejoin="round" strokeLinecap="round" strokeWidth="3" strokeMiterlimit="10" d="M32 20.8L12 2v41.2L32 62l20-18.8V2z"></path></svg>
            </span>
            <span aria-label="Innovator icon" role="img">
              <svg width="48" height="48" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="#24bac5" d="M32 20.8V62l20-18.8V2z"></path><path fill="#ffce31" d="M12 2v41.2L32 62V20.8z"></path><path fill="none" stroke="#3e4347" strokeLinejoin="round" strokeLinecap="round" strokeWidth="3" strokeMiterlimit="10" d="M32 20.8L12 2v41.2L32 62l20-18.8V2z"></path></svg>
            </span>
            <span aria-label="Innovator icon" role="img">
              <svg width="48" height="48" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="#24bac5" d="M32 20.8V62l20-18.8V2z"></path><path fill="#ffce31" d="M12 2v41.2L32 62V20.8z"></path><path fill="none" stroke="#3e4347" strokeLinejoin="round" strokeLinecap="round" strokeWidth="3" strokeMiterlimit="10" d="M32 20.8L12 2v41.2L32 62l20-18.8V2z"></path></svg>
            </span>
          </div>
          <div>
            <p className="text-lg mb-2 font-semibold">The most advanced and immersive model for schools wanting to build future innovators and leaders.</p>
            <p className="text-lg mb-2">Aaravam-trained facilitator conducts 2 sessions per week, guiding students through complex, interdisciplinary projects.</p>
            <p className="text-lg mb-2">Focus on preparing students (9th) for internships, social impact projects, research assignments, and real-world problem-solving.</p>
          </div>
          <div>
            <h3 className="font-bold text-xl mb-2 text-[#e16338]">Key Features:</h3>
            <ul className="list-disc pl-6 space-y-2 text-lg">
              <li>Full implementation by expert facilitators</li>
              <li>Hands-on design thinking sessions across the year</li>
              <li>Prototype building, field research, and problem-solving for real-world issues</li>
              <li>Career exploration and future readiness modules integrated</li>
              <li>Student exhibitions, hackathons, innovation fairs</li>
            </ul>
          </div>
        </div>
      ),
      layout: 'full',
    },
  ];
  const totalSlides = slides.length + 1; // +1 for contact slide
  const progress = ((currentSlide + 1) / totalSlides) * 100;
  const isContactSlide = currentSlide === slides.length;
  const slide = slides[currentSlide] || {};

  // Keyboard navigation for left/right arrow keys
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        setCurrentSlide((prev) => Math.max(prev - 1, 0));
      } else if (e.key === 'ArrowRight') {
        setCurrentSlide((prev) => Math.min(prev + 1, totalSlides - 1));
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [totalSlides]);

  return (
    <div className="min-h-screen bg-[#fcfbf8] flex items-center justify-center py-16 px-4 md:px-8 relative">
      {/* Fixed Slide Heading */}
      <div className="fixed top-0 left-0 w-full bg-[#fcfbf8] z-40 border-[#e16338]">
        <div className="max-w-6xl mx-auto px-4 md:px-0">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 pt-8 pb-4 inline-block bg-[#fcfbf8] w-full">
            {isContactSlide ? (
              <>Contact <span className="text-[#e16338]">Us</span></>
            ) : (
              getSlideHeading(slide.title)
            )}
          </h1>
        </div>
        {/* Progress Bar moved here */}
        <div className="h-1 w-full bg-gray-100">
          <div 
            className="h-full bg-[#e16338] transition-all duration-300 ease-out" 
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {/* Slide Content (with top padding for heading) */}
      <div className="w-full max-w-6xl mx-auto pt-10">
        {isContactSlide ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Left: Text Content */}
            <div className="flex flex-col justify-center space-y-6">
              <p className="text-xl md:text-2xl">We'd love to hear from you! Whether you're a school leader, educator, or just curious about Aaravam Labs, reach out and let's start a conversation.</p>
              <button
                onClick={() => setIsContactOpen(true)}
                className="bg-[#e16338] text-white py-3 px-8 rounded-full text-lg font-medium hover:bg-[#d55328] transition inline-flex items-center gap-2 shadow w-fit"
              >
                Get in Touch
              </button>
              <div className="text-gray-700 space-y-1">
                <div>
                  <span className="font-semibold">Email:</span> <a href="mailto:aaravam.education@gmail.com" className="text-[#e16338] hover:underline">aaravam.education@gmail.com</a>
                </div>
                <div>
                  <span className="font-semibold">Phone:</span> <a href="tel:+916385920981" className="text-[#e16338] hover:underline">+91 63859 20981</a>
                </div>
              </div>
              <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
            </div>
            {/* Right: Image */}
            <div className="flex items-center justify-center">
              <img
                src="/contact.jpg"
                alt="Contact Us"
                className="w-full object-contain"
              />
            </div>
          </div>
        ) : slide.layout === 'twocol' ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Left: Text Content */}
            <div>
              {slide.content}
            </div>
            {/* Right: Image */}
            <div className="flex items-center justify-center">
              <img 
                src={slide.image} 
                alt={slide.title} 
                className="w-full object-contain"
              />
            </div>
          </div>
        ) : (
          <div>
            {slide.content}
          </div>
        )}
      </div>

      {/* Sticky Navigation & Progress Bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
        {/* Minimal Arrow Navigation */}
        <div className="w-full flex justify-center items-center py-4">
          <div className="flex w-[220px] max-w-full bg-[#f7f7f7] rounded-full shadow-md overflow-hidden">
            <button
              className={`flex-1 flex items-center justify-center py-2 transition-all duration-200 text-xl ${
                currentSlide === 0
                  ? 'text-gray-300 cursor-not-allowed bg-[#f7f7f7]'
                  : 'text-gray-700 hover:bg-[#f0e9e2] active:bg-[#f0e9e2]'
              }`}
              onClick={() => setCurrentSlide((prev) => Math.max(prev - 1, 0))}
              disabled={currentSlide === 0}
              aria-label="Previous slide"
            >
              {/* Left Arrow SVG */}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
            </button>
            <button
              className={`flex-1 flex items-center justify-center py-2 transition-all duration-200 text-xl border-l border-gray-200 ${
                currentSlide === totalSlides - 1
                  ? 'text-gray-300 cursor-not-allowed bg-[#f7f7f7]'
                  : 'text-gray-700 hover:bg-[#f0e9e2] active:bg-[#f0e9e2]'
              }`}
              onClick={() => setCurrentSlide((prev) => Math.min(prev + 1, totalSlides - 1))}
              disabled={currentSlide === totalSlides - 1}
              aria-label="Next slide"
            >
              {/* Right Arrow SVG */}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6l6 6-6 6"/></svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurStory; 